import { ObservableArray, View } from "binder"
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { ServerSideDataLoader } from "uicomponents";
import { CarBrandManipulationViewModel, carBrand } from "./carBrandManipulation-viewModel";

export class CarBrandManipulationView extends View<CarBrandManipulationViewModel>{
    GetViewUniqueId(): string {
        return "V-425B9366-98BF-44D8-9374-47D73CD74091"
    }
    loadHtml(): string {
        let element = require('./carBrandManipulation.html').default;
        let style = require('./carBrandManipulation.less');
        return element;
    }
    constructor() {
       super();
    }

    public set carBrands(v: ObservableArray<carBrand>) { this._carBrands = v; } public get carBrands(): ObservableArray<carBrand> { return this._carBrands;} private _carBrands: ObservableArray<carBrand>;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader;} private _loader: ServerSideDataLoader;
    public set isShowingPopup(v: boolean) { this._isShowingPopup = v; } public get isShowingPopup(): boolean { return this._isShowingPopup;} private _isShowingPopup: boolean;
    public set popup(v: IPopup) { this._popup = v; } public get popup(): IPopup { return this._popup;} private _popup: IPopup;  

    requestCarBrandCreation(){
        this.dataContext.requestCarBrandCreation();
    }
}
